import { useMutation, useQueryClient } from '@tanstack/react-query';
import { Signer } from 'ethers';
import { ThirdwebSDK } from '@thirdweb-dev/react';

import HypervisorAbi from 'abis/gamma/vault.json';
import { parseUnits } from '@app/helpers/format';
import { QueryKeys } from '@app/constants/queryKeys';

async function mutation({
  address,
  vaultId,
  amount,
  signer
}: {
  address: string | undefined;
  vaultId: string | undefined;
  amount: string;
  signer: Signer | undefined;
}) {
  if (!vaultId || !address || !amount || !signer) {
    return null;
  }

  const sdk = ThirdwebSDK.fromSigner(signer);

  const contract = await sdk.getContract(vaultId, HypervisorAbi);

  // @ts-ignore
  const res = await contract.call('withdraw', [
    parseUnits(amount, 18),
    address,
    address,
    [0, 0, 0, 0]
  ]);

  return res;
}

export function useWithdrawFromVault() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: mutation,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [QueryKeys.GET_GAMMA_POSITIONS]
      });
    }
  });
}
